export const queryKeys = {
  base: (summarize?: boolean) =>
    ['edge', 'groups', 'summarize', !!summarize] as const,
  item: (id: number) => [...queryKeys.base(), id] as const,
};
